import { 
  Box, 
  Button, 
  styled 
} from '@mui/material';

const MainPageBox = styled(Box)(({theme}) => ({
  minHeight: '100dvh',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.primary.main,
  padding: '1rem'
}));

const InnerFlexBox = styled(Box)(({ theme, containerWidth, isMobile }) => ({
  width: containerWidth,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: isMobile && 'space-between',
  gap: '2rem',
  height: '100%',
}));

const SwiperSlideBox = styled(Box)(() => ({
  backgroundColor: 'rgba(255,255,255,0.1)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  height: '100%'
}));

const AuthBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
  width: '100%'
}));

const RegisterButton = styled(Button)(({ theme, isMobile }) => ({
  borderColor: theme.palette.secondary.main,
  color: theme.palette.whites.main,
  padding: isMobile ? '1rem' : '0.5rem 1rem',
  fontSize: '1.5rem',
  width: !isMobile ? '25rem' : '100%'
}));

const LoginButton = styled(Button)(({ theme, isMobile }) => ({
  padding: isMobile ? '1rem' : '0.5rem 1rem',
  fontSize: '1.5rem',
  width: !isMobile ? '25rem' : '100%',
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.primary.main,
}))

export { 
  MainPageBox,
  InnerFlexBox,
  SwiperSlideBox,
  AuthBox,
  RegisterButton,
  LoginButton
}